import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Menu,
  MenuItem,
  Button,
  Paper,
  IconButton,
  Typography,
  Modal,
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

const sampleData = [
  {
    id: 3453,
    discountCode: "Flash Sale Alert",
    percentage: "20%",
    startDate: "2023-06-01",
    endDate: "2023-06-01",
    status: "Active",
    opened: "3000",
    delivered: "2000",
  },
  {
    id: 3454,
    discountCode: "Flash Sale",
    percentage: "20%",
    startDate: "2023-06-01",
    endDate: "2023-06-01",
    status: "Inactive",
    opened: "1000",
    delivered: "1300",
  },
  {
    id: 3455,
    discountCode: "Flash Sale",
    percentage: "20%",
    startDate: "2023-06-01",
    endDate: "2023-06-01",
    status: "Scheduled",
    opened: "2000",
    delivered: "2000",
  },
];

export default function PushNotification() {
  const [data, setData] = useState(sampleData);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const handleSearch = (event) => setSearch(event.target.value);

  const handlePageChange = (event, newPage) => setPage(newPage);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page when changing rows per page
  };

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedId(null);
  };

  const handleOpenModal = (row = null) => {
    setIsEditMode(!!row);
    setSelectedRow(row);
    setModalOpen(true);
    handleMenuClose(); // Close menu when opening modal
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleDelete = () => {
    setData((prevData) => prevData.filter((row) => row.id !== selectedId));
    handleMenuClose();
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal()}
        >
          Add
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Message</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Delivered</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Opened</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.discountCode}</TableCell>
                  <TableCell>{row.percentage}</TableCell>
                  <TableCell>{row.startDate}</TableCell>
                  <TableCell>{row.delivered}</TableCell>
                  <TableCell>{row.opened}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={(event) => handleMenuOpen(event, row.id)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => handleOpenModal(row)}>
                        Edit
                      </MenuItem>
                      <MenuItem onClick={handleDelete}>Delete</MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={data.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      {/* Modal for Adding & Editing */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "white",
            border: "2px solid #00796b",
            boxShadow: 24,
            borderRadius: "8px",
            p: 4,
            position: "relative",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#00796b",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {isEditMode ? "Edit Push Notification" : "Add Push Notification"}
          </Typography>
          <TextField
            fullWidth
            label="Title"
            defaultValue={selectedRow?.discountCode || ""}
            variant="outlined"
            margin="normal"
          />
          <TextField
            name="startDate"
            label="Start Date"
            fullWidth
            margin="dense"
            value={selectedRow?.startDate }
          />

          <TextField
            fullWidth
            label="Message"
            defaultValue={selectedRow?.percentage || ""}
            variant="outlined"
            margin="normal"
          />

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              // fullWidth
              sx={{
                mt: 2,
                bgcolor: "#00796b",
                "&:hover": { bgcolor: "#005a4f" },
              }}
              onClick={handleCloseModal}
            >
              {/* {isEditMode ? "Update" : "Add "} */}
              Send
            </Button>
            <Button
              variant="contained"
              // fullWidth
              sx={{
                mt: 2,
                bgcolor: "#00796b",
                "&:hover": { bgcolor: "#005a4f" },
              }}
              onClick={handleCloseModal}
            >
              {isEditMode ? "Update" : "Create"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
